<template>
    <div class="col-md-12">
        <div class="card border px-2">
            <div class="card-header text-center">
                <h4 class="my-1">Two-factor Authentication (2FA)</h4>
            </div>
            <hr class="mt-1">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>One-time Password</label>
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="otpKey" disabled/>
                                <button
                                    class="btn btn-dark"
                                    :disabled="isWaiting"
                                    @click="requestOtp"
                                    v-tooltip="'Request a new OTP'"
                                >
                                    <template v-if="isWaiting">
                                        {{ countDownStart }}s
                                        <i class="fa-solid fa-clock-rotate-left ml-1"></i>
                                    </template>
                                    <template v-else>
                                        Get OTP
                                        <i class="fa-solid fa-key ml-1"></i>
                                    </template>
                                </button>
                                <button
                                    class="btn btn-info ml-2"
                                    @click="copyText(otpKey?.toString())"
                                    type="button"
                                    v-tooltip="'Copy to clipboard'"
                                    :disabled="!otpKey"
                                >
                                    <i class="fa fa-clipboard"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            secretKey: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                otpKey: null,
                timer: null,
                countDownStart: 0
            };
        },
        computed: {
            isWaiting() {
                return this.countDownStart > 0;
            }
        },
        methods: {
            requestOtp() {
                if (!this.secretKey || this.isWaiting) return;

                this.getOtp(this.secretKey);
                this.startTimer();
            },
            getOtp(secretKey) {
                if (this.userContainsPermission(["ADMIN", "MANAGER", "TECHNICAL_STAFF"])) {
                    const hostUrl = this.$config.aimsAPI;
                    this.showSuccess("Requesting OTP");

                    this.$http.post(`${hostUrl}otp/request`, secretKey).then(
                        (response) => {
                            this.otpKey = response.data + "";
                            this.fixOtp();
                        },
                        (error) => {
                            console.error(error);
                            this.showError("Error fetching OTP", error);
                        }
                    );
                }
            },
            fixOtp() {
                while (this.otpKey.length < 6) {
                    this.otpKey = "0" + this.otpKey
                }
            },
            startTimer() {
                this.countDownStart = 30;
                this.timer = setInterval(() => {
                    this.countDownStart--;
                    if (this.countDownStart <= 0) {
                        clearInterval(this.timer);
                        this.timer = null;
                        this.otpKey = null;
                    }
                }, 1000);
            },
            stopTimer() {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            this.stopTimer();
            next();
        },
        beforeUnmount() {
            this.stopTimer();
        }
    };
</script>

<style scoped>
.bg-dark {
    background-color: #3a3f51;
    color: #ffffff;
    font-size: 1em;
    font-weight: 600;
    width: 100px;
}
</style>